import { Status as UserStatus } from "entities/users/types";
import {
  collection,
  query,
  where,
  getCountFromServer,
  QueryConstraint,
} from "firebase/firestore";
import { db } from "shared/api/firebase";

const getUsersCountByStatuses = async (
  statuses: UserStatus[],
): Promise<number> => {
  try {
    const usersCollection = collection(db, "users");

    const queryConstraints: QueryConstraint[] = [
      where("isTelegramUser", "==", true),
    ];

    if (statuses && statuses.length > 0) {
      queryConstraints.push(where("status", "in", statuses));
    }

    const userQuery = query(usersCollection, ...queryConstraints);

    const snapshot = await getCountFromServer(userQuery);
    return snapshot.data().count;
  } catch (error) {
    console.error("Error fetching users count:", error);
    return 0;
  }
};

export default getUsersCountByStatuses;
